module.exports = __webpack_public_path__ + "img/language.b3050efa.png";